import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { MapaPeligroState, StoreError } from '@/store/modules/mapa-peligro/types'
import MapaPeligroService, { MapaPeligroInterface } from '@/domain/services/MapaPeligroService'

const MapaPeligro: MapaPeligroInterface = new MapaPeligroService()

export const actions: ActionTree<MapaPeligroState, RootState> = {
  async getMapaPeligro ({ commit }) {
    try {
      const actionResponse = await MapaPeligro.getMapaPeligro()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  deleteMapaPeligro ({ commit }) {
    return commit('MAPA_PELIGRO_DELETED', undefined)
  }
}
